// reducers
function counter(state = {}, action) {
  switch (action.type) {
    case 'CART_WISHLIST_COUNT':
      return action.counts;
    case 'UPDATE_MINI_CART':
      let newState = state;
      newState = {
        ...newState,
        count: action.count,
        cartCount: action.count,
        entries: action.entries
      };
      return newState;
    default:
      return state;
  }
}

export default counter;
